import React, { type JSX } from 'react';
import dynamic from 'next/dynamic';
import { useAppSelector } from 'src/hooks/redux-hooks';

const AddEditQuoteMaterialModal = dynamic(
  () => import('src/components/Modals/AddEditQuoteMaterialModal/index'),
  { ssr: false, loading: () => null },
);
const AddEditTagModal = dynamic(
  () => import('src/components/Modals/AddEditTagModal/AddEditTagModal'),
  { ssr: false, loading: () => null },
);
const BlockOutTimeModal = dynamic(
  () => import('src/components/Modals/BlockOutTimeModal/BlockOutTimeModal'),
  { ssr: false, loading: () => null },
);
const CommonDeleteModal = dynamic(
  () => import('src/components/Modals/CommonDeleteModal/CommonDeleteModal'),
  { ssr: false, loading: () => null },
);
const CommonModal = dynamic(() => import('src/components/Modals/CommonModal/index'), {
  ssr: false,
  loading: () => null,
});
const ConfirmationModal = dynamic(
  () => import('src/components/Modals/ConfirmationModal/ConfirmationModal'),
  { ssr: false, loading: () => null },
);
const DualActionModal = dynamic(
  () => import('src/components/Modals/DualActionModal/DualActionModal'),
  { ssr: false, loading: () => null },
);
const MFAConfigurationModal = dynamic(
  () => import('src/components/Modals/MFASettings/MFAConfigurationModal'),
  { ssr: false, loading: () => null },
);
const NewServiceRequestModal = dynamic(
  () => import('src/components/Modals/NewServiceRequestModal'),
  { ssr: false, loading: () => null },
);
const SelectedPropertiesModal = dynamic(
  () => import('src/components/Modals/SelectedPropertiesModal/SelectedPropertiesModal'),
  { ssr: false, loading: () => null },
);
const WorkOrderActions = dynamic(
  () => import('src/components/Modals/WorkOrderActions/WorkOrderActions'),
  { ssr: false, loading: () => null },
);
const SchedulingBlockoutModal = dynamic(
  () => import('src/components/Scheduling/Modals/SchedulingBlockoutModal'),
  { ssr: false, loading: () => null },
);
const ImageSliderModal = dynamic(() => import('src/components/Shared/ImageSliderModal'), {
  ssr: false,
  loading: () => null,
});
const RejectServiceRequestModal = dynamic(() => import('./RejectServiceRequestModal'), {
  ssr: false,
  loading: () => null,
});
const ResetPasswordModal = dynamic(
  () => import('src/views/Settings/Users/UserDetails/ResetPasswordModal'),
  { ssr: false, loading: () => null },
);

const Modals = (): JSX.Element => {
  const {
    confirmationModal,
    mfaConfigurationModal,
    commonDeleteModal,
    imageSlidesModal,
    blockOutTimeModal,
    workOrderActions,
    addEditTagModal,
    dualActionModal,
    commonModal,
    addEditQuoteMaterialModal,
    newServiceRequest,
    rejectServiceRequest,
    schedulingBlockoutModal,
    selectedPropertiesModal,
    resetPasswordModal,
  } = useAppSelector((state) => state.modals);

  return (
    <React.Fragment>
      {confirmationModal?.isVisible ? <ConfirmationModal /> : ''}
      {mfaConfigurationModal?.isVisible ? <MFAConfigurationModal /> : ''}
      {commonDeleteModal?.isVisible ? <CommonDeleteModal /> : ''}
      {imageSlidesModal?.isVisible ? <ImageSliderModal /> : ''}
      {blockOutTimeModal?.isVisible ? <BlockOutTimeModal /> : ''}
      {workOrderActions?.isVisible ? <WorkOrderActions /> : ''}
      {addEditTagModal?.isVisible ? <AddEditTagModal /> : ''}
      {dualActionModal?.isVisible ? <DualActionModal /> : ''}
      {commonModal?.isVisible ? <CommonModal /> : ''}
      {newServiceRequest?.isVisible ? <NewServiceRequestModal /> : ''}
      {addEditQuoteMaterialModal?.isVisible ? <AddEditQuoteMaterialModal /> : ''}
      {rejectServiceRequest?.isVisible ? <RejectServiceRequestModal /> : ''}
      {schedulingBlockoutModal?.isVisible ? <SchedulingBlockoutModal /> : ''}
      {selectedPropertiesModal?.isVisible ? <SelectedPropertiesModal /> : ''}
      {resetPasswordModal?.isVisible ? <ResetPasswordModal /> : ''}
    </React.Fragment>
  );
};

export default Modals;
